// i18n.js — textos de la interfaz en Español e Inglés
let uiLang = "es";

export const setUiLang = (l) => {
  uiLang = l === "en" ? "en" : "es";
};
export const getUiLang = () => uiLang;

const STRINGS = {
  es: {
    searchMovie: "Buscar película…",
    searchTv: "Buscar serie…",
    movies: "Películas",
    series: "Series",
    allGenres: "Todos los géneros",
    filters: "Filtros",
    results: "Resultados",
    noResults: "No se encontraron resultados.",
    loadMore: "Cargar más",
    loading: "Cargando…",
    favorites: "Tus favoritos",
    recommended: "Recomendadas",
    trending: "Tendencias de la semana",
    inTheaters: "En cines",
    addFav: "Añadir a favoritos",
    removeFav: "Quitar de favoritos",
    seeMore: "Ver más",
    seeMoreTitle: "Ver ficha ampliada (reparto, reseñas y similares)",
    availableOn: "Disponible en:",
    direction: "Dirección:",
    creation: "Creación:",
    trailer: "Tráiler",
    movie: "Película",
    serie: "Serie",
    votes: "votos",
    sensitive: "Contenido sensible",
    clickToView: "Clic para ver",
    errorLoad: "No se pudo cargar. Revisa tu conexión.",
    retry: "Reintentar",
    tmdb: "Datos por The Movie Database (TMDb). Este producto usa la API de TMDb pero no está avalado ni certificado por TMDb.",
    share: "Compartir",
    shareNative: "Compartir…",
    copyLink: "Copiar enlace",
    copied: "¡Copiado!",
    // Configuración
    sort: "Ordenar",
    popular: "Populares",
    recent: "Recientes",
    topRated: "Mejor valoradas",
    allTime: "Todo el tiempo",
    onClickTitle: "Al hacer clic en un póster",
    inline: "Integrada",
    windowMode: "Ventana",
    theme: "Tema",
    light: "Claro",
    dark: "Oscuro",
    content: "Contenido para adultos",
    free: "Libre",
    censor: "Censurar",
    hide: "Ocultar",
    language: "Idioma",
    linkTitle: "Enlace del botón",
    urlBase: "URL base",
    buttonText: "Texto del botón",
    resetImdb: "Restablecer a IMDb",
    // Modales
    cast: "Reparto",
    reviews: "Reseñas",
    similar: "Similares",
    noCast: "No hay información de reparto.",
    noReviews: "Todavía no hay reseñas para este título.",
    noSimilar: "No hay títulos similares.",
    readMore: "Leer más",
    seeLess: "Ver menos",
    allReviews: "Ver todas las reseñas",
    knownFor: "Conocido por:",
    birth: "Nacimiento:",
    death: "Fallecimiento:",
    age: "Edad:",
    yearsOld: "años",
    alsoKnownAs: "También conocido como:",
    website: "Sitio web:",
    filmography: "Filmografía",
    noBio: "No hay biografía disponible.",
    noFilmo: "No hay filmografía disponible.",
    close: "Cerrar",
  },
  en: {
    searchMovie: "Search movie…",
    searchTv: "Search series…",
    movies: "Movies",
    series: "Series",
    allGenres: "All genres",
    filters: "Filters",
    results: "Results",
    noResults: "No results found.",
    loadMore: "Load more",
    loading: "Loading…",
    favorites: "Your favorites",
    recommended: "Recommended",
    trending: "Trending this week",
    inTheaters: "In theaters",
    addFav: "Add to favorites",
    removeFav: "Remove from favorites",
    seeMore: "See more",
    seeMoreTitle: "See full details (cast, reviews and similar)",
    availableOn: "Available on:",
    direction: "Directed by:",
    creation: "Created by:",
    trailer: "Trailer",
    movie: "Movie",
    serie: "Series",
    votes: "votes",
    sensitive: "Sensitive content",
    clickToView: "Click to view",
    errorLoad: "Couldn't load. Check your connection.",
    retry: "Retry",
    tmdb: "Data by The Movie Database (TMDb). This product uses the TMDb API but is not endorsed or certified by TMDb.",
    share: "Share",
    shareNative: "Share…",
    copyLink: "Copy link",
    copied: "Copied!",
    sort: "Sort",
    popular: "Popular",
    recent: "Recent",
    topRated: "Top rated",
    allTime: "All time",
    onClickTitle: "When clicking a poster",
    inline: "Inline",
    windowMode: "Window",
    theme: "Theme",
    light: "Light",
    dark: "Dark",
    content: "Adult content",
    free: "Free",
    censor: "Censor",
    hide: "Hide",
    language: "Language",
    linkTitle: "Button link",
    urlBase: "Base URL",
    buttonText: "Button text",
    resetImdb: "Reset to IMDb",
    cast: "Cast",
    reviews: "Reviews",
    similar: "Similar",
    noCast: "No cast information.",
    noReviews: "No reviews yet for this title.",
    noSimilar: "No similar titles.",
    readMore: "Read more",
    seeLess: "Show less",
    allReviews: "See all reviews",
    knownFor: "Known for:",
    birth: "Born:",
    death: "Died:",
    age: "Age:",
    yearsOld: "years old",
    alsoKnownAs: "Also known as:",
    website: "Website:",
    filmography: "Filmography",
    noBio: "No biography available.",
    noFilmo: "No filmography available.",
    close: "Close",
  },
};

export const t = (key) => (STRINGS[uiLang] && STRINGS[uiLang][key]) || key;
